import React, { useEffect, useRef } from 'react';

const Particles: React.FC = () => {
  const particlesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const createParticles = () => {
      const particlesContainer = particlesRef.current;
      if (!particlesContainer) return; const particleCount = 50;

      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        // More subtle: smaller, lighter, more transparent
        particle.className = 'absolute w-0.5 h-0.5 bg-white/20 rounded-full';
        particle.style.left = Math.random() * 100 + '%';
        particle.style.top = '100%';
        // All particles move upward (one direction)
        particle.style.animation = `particle-float-up ${(Math.random() * 10 + 32)}s linear ${(Math.random() * 20)}s infinite`;
        particlesContainer.appendChild(particle);
      }
    };

    createParticles();

    return () => {
      if (particlesRef.current) {
        particlesRef.current.innerHTML = '';
      }
    };
  }, []);
  return (
    <div
      ref={particlesRef}
      className="fixed top-0 left-0 z-0 w-full h-full overflow-hidden pointer-events-none"
      style={{ willChange: 'opacity' }}
    />
  );
};

export default Particles;
